import { DateTime } from 'luxon';

export function formatDateForFilter(date: string, format: 'INF' | 'SUP'): string {
  if (!date) {
    let dateTime = DateTime.now();
    if (format === 'INF') {
      dateTime = dateTime.minus({ years: 100 });
    } else if (format === 'SUP') {
      dateTime = dateTime.plus({ years: 100 });
    }
    return dateTime.toFormat('yyyy-MM-dd');
  }
  return date;
}

export function compareByNumber(aValue: string, bValue: string): number {
  return Number(aValue) - Number(bValue);
}
